/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TombstoneRip} from "../../TombstoneRip";
import {TombstoneRipSymbolState} from "../../symbol/TombstoneRipSymbolConfig";
import {TombstoneRipGameMode} from "../../gameflow/TombstoneRipGameMode";

export class ReelWinHintController extends ReelStopPresentationController {

    private _excludeSymbols = ["S1", "S2", "WRS", "WXS"];

    constructor() {
        super("ReelWinHintController");
    }

    protected async onReelBounce(data:IReelStateEventData):Promise<any> {
        if(data.reelId < 2 || TombstoneRip.model.parsedGameData.betWinsBeforeTwoScatter.length === 0) {
            return Promise.resolve();
        }

        if(TombstoneRip.model.data.mode === TombstoneRipGameMode.FREESPIN_SUPER && data.reelId === 4) {
            return Promise.resolve();
        }

        // darken down no win symbols from reel 3.
        if(data.reelId === 2) {
            await Promise.all([0, 1, 2].map(reelId => this.hintReel(reelId)));
        } else {
            await this.hintReel(data.reelId);
        }
    }

    private async hintReel(reelId:number):Promise<any> {
        let winPositions = [false, false, false];
        TombstoneRip.model.parsedGameData.betWinsBeforeTwoScatter.forEach(w => {
            w[reelId].forEach((symbolWin, symId) => {
                if(symbolWin) {
                    winPositions[symId] = true;
                }
            });
        });

        const promises:Promise<any>[] = [];
        winPositions.forEach((win, symId) => {
            const symbol = TombstoneRip.reels[reelId].getSymbol(symId);
            if((!win && !this._excludeSymbols.includes(symbol.symbolName)) || this.isNudgeAwayNoWinSymbol(reelId, symbol.symbolName)) {
                promises.push(Promise.resolve(symbol.getStateAnimation(
                    TombstoneRipSymbolState.NO_WIN_HINT,
                    {duration : 0.1, alpha : 1},
                    {duration : 0.1, alpha : 0}
                )));
            }
        });

        await Promise.all(promises);
    }

    private isNudgeAwayNoWinSymbol(reelId:number, symName:string):boolean {
        if(!TombstoneRip.model.parsedGameData.doReelNudge[reelId]) {
            return false;
        }

        let isWinSymbol:boolean = false;
        TombstoneRip.model.parsedGameData.betWins.forEach(w => {
            if(w.symbol === symName || symName.includes("W")) {
                isWinSymbol = true;
            }
        });

        return !isWinSymbol;
    }
}